import axios from "axios";

export const SAVE_INTEGRATION_REQUEST = "SAVE_INTEGRATION_REQUEST";
export const SAVE_INTEGRATION_SUCCESS = "SAVE_INTEGRATION_SUCCESS";
export const SAVE_INTEGRATION_FAILURE = "SAVE_INTEGRATION_FAILURE";

export const FETCH_KLAVIYO_TEMPLATES_REQUEST = "FETCH_KLAVIYO_TEMPLATES_REQUEST";
export const FETCH_KLAVIYO_TEMPLATES_SUCCESS = "FETCH_KLAVIYO_TEMPLATES_SUCCESS";
export const FETCH_KLAVIYO_TEMPLATES_FAILURE = "FETCH_KLAVIYO_TEMPLATES_FAILURE";

export const FETCH_PARCEL_PANEL_REQUEST = "FETCH_KLAVIYO_TEMPLATES_REQUEST";
export const FETCH_PARCEL_PANEL_SUCCESS = "FETCH_PARCEL_PANEL_SUCCESS";
export const FETCH_PARCEL_PANEL_FAILURE = "FETCH_PARCEL_PANEL_FAILURE";

export const saveIntegrationRequest = () => {
    return {
        type: SAVE_INTEGRATION_REQUEST,
    };
};

export const saveIntegrationSuccess = (reviews) => {
    return {
        type: SAVE_INTEGRATION_SUCCESS,
        payload: reviews,
    };
};

export const saveIntegrationFailure = (error) => {
    return {
        type: SAVE_INTEGRATION_FAILURE,
        payload: error,
    };
};

export const fetchKlaviyoTemplatesRequest = () => {
    return {
        type: FETCH_KLAVIYO_TEMPLATES_REQUEST,
    };
};

export const fetchKlaviyoTemplatesSuccess = (templates) => {
    return {
        type: FETCH_KLAVIYO_TEMPLATES_SUCCESS,
        payload: templates,
    };
};

export const fetchKlaviyoTemplatesFailure = (error) => {
    return {
        type: FETCH_KLAVIYO_TEMPLATES_FAILURE,
        payload: error,
    };
};

export const fetchParcelPanelRequest = () => {
    return {
        type: FETCH_PARCEL_PANEL_REQUEST,
    };
};

export const fetchParcelPanelSuccess = (templates) => {
    return {
        type: FETCH_PARCEL_PANEL_SUCCESS,
        payload: templates,
    };
};

export const fetchParcelPanelFailure = (error) => {
    return {
        type: FETCH_PARCEL_PANEL_FAILURE,
        payload: error,
    };
};


export const savePushOwlIntegration = (data) => {
    return async (dispatch) => {
        dispatch(saveIntegrationRequest());
        try {
            const response = await axios.post("/pushowl/save", data);
            dispatch(saveIntegrationSuccess(response.data));
        } catch (error) {
            dispatch(saveIntegrationFailure(error.message));
        }
    };
};

export const saveKlaviyoIntegration = (data) => {
    return async (dispatch) => {
        dispatch(saveIntegrationRequest());
        try {
            const response = await axios.post("/klaviyo/save", data);
            dispatch(saveIntegrationSuccess(response.data));
        } catch (error) {
            dispatch(saveIntegrationFailure(error.message));
        }
    };
};

export const getKlaviyoTemplates = () => {
    return async (dispatch) => {
        dispatch(fetchKlaviyoTemplatesRequest());
        try {
            const response = await axios.get("/klaviyo/templates");
            dispatch(fetchKlaviyoTemplatesSuccess(response.data));
        } catch (error) {
            dispatch(fetchKlaviyoTemplatesFailure(error.message));
        }
    };
};

export const createKlavioSampleTemplate = () => {
    return async (dispatch) => {
        const requestUrl = "/klaviyo/create-sample-template";
        try {
            const response = await axios.post(`${requestUrl}`);
            dispatch(fetchKlaviyoTemplatesSuccess(response.data));
        } catch (error) {
            dispatch(fetchKlaviyoTemplatesFailure(error.message));
        }
    };
};

export const triggerKlavioSampleEvent = () => {
    const requestUrl = "/klaviyo/trigger-sample-event";
    return {
        type: "TRIGGER_KLAVIYO_SAMPLE_EVENT",
        payload: axios.get(`${requestUrl}`),
    };
};

export const getParcelPanel = () => {
    return async (dispatch) => {
        dispatch(fetchParcelPanelRequest());
        try {
            const response = await axios.get("/get-parcel-panel");
            dispatch(fetchParcelPanelSuccess(response.data));
        } catch (error) {
            dispatch(fetchParcelPanelFailure(error.message));
        }
    };
};

export const saveParcelPanel = (data) => {
    return async (dispatch) => {
        dispatch(saveIntegrationRequest());
        try {
            const response = await axios.post("/save-parcel-panel", data);
            dispatch(saveIntegrationSuccess(response.data));
        } catch (error) {
            dispatch(saveIntegrationFailure(error.message));
        }
    };
};